export const ERROR_CODES = [
    'request.executionDeadline',
    // Axiom
    'axiom.queryRejected',
    'axiom.tokenInvalid',
    // Invite
    'invite.emailSendFailed',
    'invite.linkNotFound',
    'invite.linkExpired',
    'invite.authMethodNotAllowed',
    'invite.userAlreadyExists',
    'invite.userNotFoundInAuth0',
    'invite.orgMaxUsers',
    'invite.fleetClientRequired',
    'invite.fleetModuleRequired',
    'invite.fleetClientWithoutPortalRole',
    'invite.portalRolesExclusive',
    'invite.userAlreadyInOrg',
    'invite.userDisabledInOrg',
    // User
    'user.notFound',
    'user.alreadyExists',
    'user.phoneAlreadyTaken',
    'user.ssoIdentityNotVerified',
    'user.ssoIdentityCollision',
    'user.identityDisabled',
    // Password policy: Auth0 refused a new password
    'password.tooWeak',
    'password.tooCommon',
    'password.containsUserInfo',
    'password.rejected',
    // Password reset
    'reset.linkExpired',
    'reset.linkInvalid',
    'reset.ssoUser',
    // Email
    'email.attachmentTooLarge',
    'email.domainNotVerified',
    'email.invalidRecipient',
    'email.providerRejected',
    'email.providerUnavailable',
    'email.unknown',
    // Training record
    'trainingRecord.currentTrainingPeriodNotFound',
    // Handling party
    'handlingParty.alreadyExists',
    'recordNotFound',
    // Claim status
    'claimStatus.alreadyExists',
    'unauthorized',
    // Communication template
    'commTemplate.alreadyExists',
    // Communication signature
    'commSignature.alreadyExists',
    // Insurer
    'insurer.alreadyExists',
    // Product type
    'productType.alreadyExists',
    // Product type state (CUR-473)
    'productTypeState.alreadyExists',
    // Product
    'product.alreadyExists',
    // Product version
    'productVersion.alreadyExists',

    // Product version — contact types
    'productVersionContactType.alreadyExists',
    'productVersionContactType.roleTaken',
    'productVersionContactType.roleAlreadyOnVersion',
    'orgContactRole.alreadyExists',
    'orgContactRole.roleInUse',
    // Product version — form field mappings
    'productVersionFieldMapping.targetTaken',
    'productVersionFieldMapping.batchTimedOut',
    // Product version — export and import as a bundle (CUR-1893)
    'productVersionBundle.confirmationRequired',
    // Lodgement v2 public surface (docs/plan/product-version-public-lodgement/lodgement-v2-design.md § 4)
    'lodgement.formChanged',
    'lodgement.validationFailed',
    'lodgement.draftNotEditable',
    'lodgement.linkPaused',
    'lodgement.fileLimitReached',
    'lodgement.fileTypeNotAccepted',
    'lodgement.fileTooLarge',
    // Deferred product binding (CUR-2160)
    'claimBinding.versionNotPublished',
    'claimBinding.notAwaitingProduct',
    'claimBinding.productRequired',
    // Claim intake forms (CUR-2165, CUR-2194): a published version without the questions the claim is built from
    'claimIntake.questionsMissing',
    // Changing a claim's product (CUR-2193)
    'claimBinding.notChangeable',
    'claimBinding.sameVersion',
    'claimBinding.hasFinancialRecords',
    'claimBinding.codesOffProduct',
    // An owner-editor save loaded before the claim's product changed
    'claimBinding.productChanged',
    // Closing a claim with an outcome (CUR-2167)
    'claimClosure.notOpen',
    'claimClosure.chooseStatus',
    'claimClosure.noClosedStatus',
    'claimClosure.outcomeNeedsProduct',
    'claimClosure.outcomeHasMoney',
    'claimClosure.duplicateTarget',
    // Closing a claim under payment approval while money is left on a reserve, a reserve change waits
    // or a payment is not finished (CUR-2790): refused however it is closed (PRECONDITION).
    'claimClosure.workLeft',
    // AI claim lodgement from documents (CUR-1742)
    'aiLodgement.fileType',
    'aiLodgement.emailTooLarge',
    'aiLodgement.tooManyFiles',
    'aiLodgement.runTooLarge',
    'aiLodgement.noFiles',
    'aiLodgement.runNotUploading',
    'aiLodgement.runEnded',
    'aiLodgement.notAwaitingProduct',
    'aiLodgement.productBeingChosen',
    'aiLodgement.productAlreadyChosen',
    'aiLodgement.incidentAlreadyChosen',
    'aiLodgement.draftUnavailable',
    'aiLodgement.notReady',
    'aiLodgement.alreadyLodged',
    'aiLodgement.notPrefilling',
    'aiLodgement.productLocked',
    'aiLodgement.draftReplaced',
    'aiLodgement.attachingToClaim',
    'aiLodgement.attachInProgress',
    'aiLodgement.runBeingLodged',
    'aiLodgement.filesGone',
    'aiLodgement.singleIncident',
    'aiLodgement.uploadMissing',
    // A claim recorded from a run without a product (CUR-2166): the run changed while it was recorded.
    'aiLodgement.runChanged',
    // Catastrophe event
    'catastropheEvent.alreadyExists',
    // Org email ID (AI inbox / managed inbound local part — docs/plan/ai-inbox-self-service)
    'org.emailIdAlreadyExists',
    'org.emailIdPreviouslyHeld',
    'org.emailIdNotAvailable',
    'org.logoUnavailable',
    // Register (CUR-644)
    'register.templateAlreadyInstalled',
    'register.nameTaken',
    'register.duplicateFieldLabel',
    'register.staleBuilderPayload',
    'register.orgRegisterCapReached',
    // Register delete / restore (CUR-1232)
    'register.registerDeleted',
    'register.registerNotDeleted',
    // Register records (CUR-644 phase 3)
    'register.unknownField',
    'register.archivedField',
    'register.invalidFieldValue',
    'register.requiredFieldMissing',
    'register.recordBinned',
    'register.recordNotBinned',
    // Register record links (CUR-644 phase 4)
    'register.linkAlreadyExists',
    'register.linkGroupFull',
    // Register CSV import/export (CUR-644 phase 7)
    'register.importChangedSincePreview',
    'register.importValidationFailed',
    'register.importRowCapExceeded',
    'register.importMappingInvalid',
    'register.exportRowCapExceeded',
    'register.exportTooLarge',
    'register.registerBusy',
    // Register snapshots (CUR-644 phase 6)
    'register.snapshotNameTaken',
    'register.snapshotCapReached',
    // Scheduled snapshots (CUR-722)
    'register.snapshotScheduleNameTaken',
    'register.snapshotScheduleCapReached',
    'register.snapshotScheduleStartInPast',
    'register.snapshotScheduleBusy',
    'register.snapshotScheduleSpent',
    'register.snapshotScheduleOwnerInactive',
    'register.snapshotOccurrenceCaptured',
    'register.snapshotTooLarge',
    // Scheduled user attestations (CUR-858)
    'userAttestation.scheduleBusy',
    'userAttestation.scheduleSendDateInPast',
    'userAttestation.scheduleSpent',
    'userAttestation.scheduleOwnerInactive',
    'userAttestation.scheduleOccurrenceIssued',
    'userAttestation.scheduleCapReached',
    // Claim flag
    'claimFlag.alreadyExists',
    // Claims authority (CUR-1633)
    'claimAuthorityLevel.alreadyExists',
    'claimAuthorityLevel.inUse',
    'claimAuthority.managerNotAvailable',
    'claimAuthority.reportingLineLoop',
    // Claims authority enforcement (CUR-1641)
    'claimAuthority.noLevel',
    'claimAuthority.changePending',
    // Deciding a held reserve change (CUR-1642)
    'claimAuthority.alreadyDecided',
    'claimAuthority.notAssignee',
    'claimAuthority.ownRequest',
    'claimAuthority.needsInsurer',
    'claimAuthority.notReferral',
    'claimAuthority.claimClosed',
    'claimAuthority.nobodyToResend',
    // Raising a payment for approval (CUR-2671): the steps or the people chosen changed since the
    // preview (CONFLICT), or today's payment form tried to save a payment that needs approval
    // (PRECONDITION). Today's form is also refused (PRECONDITION, retryable) where approval could apply
    // but its flags could not be evaluated, which is logged. All three use `captureInSentry: false`.
    'claimPaymentApproval.planChanged',
    'claimPaymentApproval.approvalRequired',
    'claimPaymentApproval.unavailable',
    // Deciding a payment raised for approval (CUR-2673): it moved on from the step decided, or its claim
    // closed (CONFLICT); only its step's person or its raiser may do that (FORBIDDEN); the step needs
    // the insurer, is not a referral, or the decider's limit no longer covers it (PRECONDITION). All
    // use `captureInSentry: false`: several name people.
    'claimPaymentApproval.alreadyDecided',
    'claimPaymentApproval.claimClosed',
    'claimPaymentApproval.notAssignee',
    'claimPaymentApproval.notRaiser',
    'claimPaymentApproval.ownPayment',
    'claimPaymentApproval.ownReferral',
    'claimPaymentApproval.needsInsurer',
    'claimPaymentApproval.notReferral',
    'claimPaymentApproval.limitNoLongerCovers',
    // Accounts approval (CUR-2675): only someone with the Accounts role who did not raise, authorise or
    // sign off a payment gives its final approval, and once anyone holds the role they mark payments
    // paid (FORBIDDEN). A payment needing accounts approval that nobody may give, turning Accounts approval
    // on while nobody holds the role, and taking the role from its last holder while it is needed, are
    // refused (PRECONDITION). All use `captureInSentry: false`.
    'claimPaymentApproval.notAccounts',
    'claimPaymentApproval.accountsInvolved',
    'claimPaymentApproval.accountsMarkPaid',
    'claimPaymentApproval.noAccountsApprover',
    'claimPaymentApproval.noAccountsHolder',
    'claimPaymentApproval.lastAccountsHolder',
    // A role that waits on a feature flag the organisation does not have on (CUR-2675, BAD_REQUEST), and a
    // role change that met someone else giving the Accounts role to the same person meanwhile (CONFLICT).
    'user.roleUnavailable',
    'user.changedMeanwhile',
    // A payment's attachments are locked once it is raised for approval (CUR-2672, decision 6): a file
    // added while it waits, or removed from it, is refused (PRECONDITION, `captureInSentry: false`).
    // CUR-2767: so is trashing a claim Library file a raised payment links as a document, or holds as
    // its insurer's approval or proof of payment.
    'claimPaymentApproval.filesLocked',
    // CUR-2672 (JLo, CUR-2772 req 3): a payment is sent for approval only to a payee with bank details
    // (PRECONDITION, `captureInSentry: false`).
    'claimPaymentApproval.payeeNoBankDetails',
    // Insurer limits (CUR-2674): the insurer and product type already have a limit (CONFLICT), or a
    // claim's insurer was changed while a payment or reserve change on it waits (PRECONDITION). With
    // payment approval on, a claim's insurer is locked once money is on it (CUR-2778, PRECONDITION).
    'claimAuthorityInsurerLimit.alreadyExists',
    'claimAuthority.insurerChangeWhileWaiting',
    'claimAuthority.insurerLocked',
    // A reserve change, its preview or a decision where claims authority could apply but its rollout
    // flags could not be evaluated (CUR-2724): refused (PRECONDITION, retryable) and logged, with
    // `captureInSentry: false`.
    'claimAuthority.unavailable',
    // Bank files (CUR-2807, CUR-2808): the rollout flags could not be evaluated (PRECONDITION, retryable);
    // the organisation's bank account already exists, or a change found none (CONFLICT), can't be saved while nobody holds the
    // Accounts role, or with claim numbers a bank file can't carry (V18), or while the payee data keys are
    // not set in the environment (PRECONDITION); Claim ID configuration refuses a format bank files can't
    // carry while the organisation has a bank account (PRECONDITION). All `captureInSentry: false` except
    // the keys.
    'bankFiles.unavailable',
    'orgBankAccount.exists',
    'orgBankAccount.missing',
    'orgBankAccount.noAccountsHolder',
    'orgBankAccount.claimNumbers',
    'orgBankAccount.keysUnavailable',
    'idGenerator.bankFileClaimNumbers',
    // Complaint flag
    'complaintFlag.alreadyExists',
    // Incident flag
    'incidentFlag.alreadyExists',
    // Incident submission idempotency — the submission identity was already
    // completed with different details (typically from another tab or device).
    'incident.submissionConflict',
    /**
     * Financials
     */
    // Transaction type
    'transactionType.alreadyExists',
    // Compensation payment
    'compensationPayment.totalAmountGreaterThanRemainingReserveAmount',
    // Excess payment
    'excessPayment.totalExcessAmountGreaterThanPaymentItemsTotalAmount',
    // Vehicle assessment (Clear21) — signals that a correlation row was persisted
    // for this attempt (sent-pending or failed), so the client should dismiss the
    // form and refetch. Its ABSENCE on a PRECONDITION means nothing was recorded
    // (e.g. a pre-persistence repairer-resolution failure), so the form stays open.
    'vehicleAssessment.requestRecorded',
    // Another manual or automatic request currently owns the claim-scoped lease.
    'vehicleAssessment.requestInProgress',
    // The claim's excess outcome moved off the coordinated evaluation between
    // dispatch reservation and assessment persistence — nothing was recorded.
    'vehicleAssessment.staleExcessOutcome',
    // Vehicle inspection (Ravin) — a paid run was refused because the claim already
    // holds a Clear21 repair quote and the handler had not acknowledged it (CUR-1237).
    // Nothing was sent; the form shows the quote and asks again.
    'vehicleInspection.existingRepairQuote',
    // A photo push was refused because it lacks what Ravin needs to report automatically
    // (CUR-1855): wide angles, plate photo, odometer, plate or state. Nothing was sent; the
    // picker reloads so its checklist shows what the server saw.
    'vehicleInspection.incompleteCapture',
    // AI pre-send sanitisation (CUR-1730) — an interactive AI action was blocked because
    // personal information could not be replaced before the provider call. Thrown as a
    // PRECONDITION with the fixed message "AI is temporarily unavailable"; the client matches
    // on this id, not the message, to show its own copy.
    'ai.temporarilyUnavailable',
    // Organisation settings — expected refusals of a control-centre save or reset: the value
    // moved on since the editor loaded it (CONFLICT), or it fails the setting's rules
    // (BAD_REQUEST). The editor shows both itself, so neither end reports them to Sentry.
    'orgSetting.stale',
    'orgSetting.invalidValue',
    // Obligation versions (CUR-2023) — publishing a new version was refused because an older
    // version of the same obligation is still awaiting review or in draft. Thrown as a
    // PRECONDITION with a message naming that version; nothing was changed. The client matches on
    // this id to keep the designed refusal out of Sentry.
    'obligation.olderVersionUnpublished',
    // Obligation versions (CUR-2728) — moving a new version to Draft or Awaiting review was refused
    // because another version of the same obligation is still open: the version in force, or an
    // older version awaiting review or in draft. Thrown as a PRECONDITION with a message naming that
    // version; nothing was changed. The server marks it clientCapture:false, so neither end reports it.
    'obligation.newVersionAwaitingPublish',
    // Obligation versions (CUR-2499) — publishing a new version with no effective from date was
    // refused because the version it replaces only takes effect on or after the publish day, so
    // closing it would leave it no day in force. Thrown as a PRECONDITION naming that version and
    // its start date; nothing was changed.
    'obligation.predecessorNotYetInForce',
    // Captcha (CUR-1962) — a public request refused because no Turnstile challenge passed, thrown
    // as UNAUTHORIZED. When the server keeps it out of Sentry, the client matches on this id to
    // leave it to the server too, and still reports a quiet session refusal, which it alone can judge.
    'captcha.rejected',
] as const;

export type CuriumErrorCode = (typeof ERROR_CODES)[number];

/**
 * Expected outcomes of validating a password reset link: the user followed a used,
 * expired or SSO-account link. The server throws them with `captureInSentry: false`
 * and the client classifier skips capture for the same codes.
 */
export const PASSWORD_RESET_LINK_ERROR_CODES = [
    'reset.linkExpired',
    'reset.linkInvalid',
    'reset.ssoUser',
] as const satisfies readonly CuriumErrorCode[];

/**
 * Expected outcomes of setting a person's claims authority (CUR-1633): the server refuses the
 * chosen manager with `captureInSentry: false` and the panel shows the reason on the field. The
 * reporting-loop message names the people on the line, so the client classifier skips capture too.
 */
export const CLAIM_AUTHORITY_MANAGER_ERROR_CODES = [
    'claimAuthority.reportingLineLoop',
    'claimAuthority.managerNotAvailable',
] as const satisfies readonly CuriumErrorCode[];

/**
 * Expected refusals of a reserve change under claims-authority enforcement (CUR-1641). The
 * pending-change message names the person the change is waiting on, so neither side captures it.
 */
export const CLAIM_AUTHORITY_RESERVE_CHANGE_ERROR_CODES = [
    'claimAuthority.noLevel',
    'claimAuthority.changePending',
] as const satisfies readonly CuriumErrorCode[];

/**
 * Expected refusals when deciding or re-sending a held reserve change (CUR-1642), or recording the
 * insurer's approval of a referral (CUR-1643). Several name the person the change is waiting on,
 * so neither side captures them.
 */
export const CLAIM_AUTHORITY_DECISION_ERROR_CODES = [
    'claimAuthority.alreadyDecided',
    'claimAuthority.notAssignee',
    'claimAuthority.ownRequest',
    'claimAuthority.needsInsurer',
    'claimAuthority.notReferral',
    'claimAuthority.claimClosed',
    'claimAuthority.nobodyToResend',
] as const satisfies readonly CuriumErrorCode[];

/**
 * Expected refusals when deciding a payment raised for approval or marking it paid (CUR-2673).
 * Several name the person the payment waits on or who raised it, so neither side captures them.
 */
export const CLAIM_PAYMENT_DECISION_ERROR_CODES = [
    'claimPaymentApproval.alreadyDecided',
    'claimPaymentApproval.claimClosed',
    'claimPaymentApproval.notAssignee',
    'claimPaymentApproval.notRaiser',
    'claimPaymentApproval.ownPayment',
    'claimPaymentApproval.ownReferral',
    'claimPaymentApproval.needsInsurer',
    'claimPaymentApproval.notReferral',
    'claimPaymentApproval.limitNoLongerCovers',
    'claimPaymentApproval.notAccounts',
    'claimPaymentApproval.accountsInvolved',
    'claimPaymentApproval.accountsMarkPaid',
] as const satisfies readonly CuriumErrorCode[];

/** Deadline expiry does not imply rollback of an in-progress mutation. */
export const EXECUTION_DEADLINE_MESSAGE =
    'This request took too long. Work may still finish. Check the outcome before trying again.';
